import React from 'react'
import theme from '../config/theme'

interface BreadcrumbItem {
  label: string
  path?: string
  onClick?: () => void
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <span className="mx-2 text-base" style={{ color: theme.color.gray200 }}>
              /
            </span>
          )}
          {index === items.length - 1 ? (
            <span className="text-base font-semibold" style={{ color: theme.color.gray500 }}>
              {item.label}
            </span>
          ) : (
            <span 
              className="text-base cursor-pointer hover:underline" 
              style={{ color: theme.color.gray200 }}
              onClick={item.onClick}
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default Breadcrumb

